
      var _image, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 120,
  height: 120,
  textRendering: "geometricPrecision",
  viewBox: "0 0 120 120"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
  id: "logo_6d6e9a70a3bc6947__a",
  width: 120,
  height: 120,
  x: 0,
  y: 0,
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("image", {
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAB4CAMAAAAOusbgAAAAIVBMVEVMaXH///////////////////////////////////////8c1D1MAAAACnRSTlMAShEovPB5leDQZCHg2QAAAAlwSFlzAAAD6AAAA+gBtXtSawAAAOtJREFUeNrt1OuOgyAQQGEYHMB5/wde6oq7kIY2YhObnO+POTFBuahzAADgbuTrBr7xawnnCQAAAAA+Isi4vYzyvGjWDJVM3aCT5Utm69xi5h/Xd7pc1Mwdt0/zpr4MHBdLTa9H5/8dS1p5j2xxfpmrrZcjtevlSc6sdK4j+bZ1b226yym/k9C6abI+b2kyTx9sqYuXwzsd1vb2eanb07/O3R6v1+5xOaOpzCLlfaS4nWBLerTunWqWp8Y9p54ctu9U6u/oRZfL4wMQf8U/pCxv6Fra46eDnDlgPow7hkECAAAAAAAAAAAAwHk/auULd1tG0d4AAAAASUVORK5CYII=",
  width: 120,
  height: 120,
  href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAB4CAMAAAAOusbgAAAAIVBMVEVMaXH///////////////////////////////////////8c1D1MAAAACnRSTlMAShEovPB5leDQZCHg2QAAAAlwSFlzAAAD6AAAA+gBtXtSawAAAOtJREFUeNrt1OuOgyAQQGEYHMB5/wde6oq7kIY2YhObnO+POTFBuahzAADgbuTrBr7xawnnCQAAAAA+Isi4vYzyvGjWDJVM3aCT5Utm69xi5h/Xd7pc1Mwdt0/zpr4MHBdLTa9H5/8dS1p5j2xxfpmrrZcjtevlSc6sdK4j+bZ1b226yym/k9C6abI+b2kyTx9sqYuXwzsd1vb2eanb07/O3R6v1+5xOaOpzCLlfaS4nWBLerTunWqWp8Y9p54ctu9U6u/oRZfL4wMQf8U/pCxv6Fra46eDnDlgPow7hkECAAAAAAAAAAAAwHk/auULd1tG0d4AAAAASUVORK5CYII=",
  preserveAspectRatio: "none",
  style: {
    imageRendering: "crisp-edges"
  }
}))), _image || (_image = /*#__PURE__*/React.createElement("image", {
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAB4CAMAAAAOusbgAAAAGFBMVEVMaXEAAAAAAAAAAAAAAAAAAAAAAAAAAACrC2ehAAAAB3RSTlMAgEa04PDQNfppbQAAAAlwSFlzAAAD6AAAA+gBtXtSawAAAJ1JREFUeNrt2sENwyAMQFEwEPbfuGIB3IvbHN4fIC8ykYgErUmSpNcVvaTI2LmLmnd67bLWzR27sHGBz6Br1vgM+wKfF6v5ZpMng8FgMBgMBoPBYDAYDAaDwWAwGAwGg8Fg8Kvhc24dFW4kJ9d/O7iOSvg6yl7n9mQxRsm9iDmiSZJ+UE+uma1eBKfbxyyCnwx+iuBIflBsfZIk6bs++Tcjn3XmlBsAAAAASUVORK5CYII=",
  width: 120,
  height: 120,
  href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAB4CAMAAAAOusbgAAAAGFBMVEVMaXEAAAAAAAAAAAAAAAAAAAAAAAAAAACrC2ehAAAAB3RSTlMAgEa04PDQNfppbQAAAAlwSFlzAAAD6AAAA+gBtXtSawAAAJ1JREFUeNrt2sENwyAMQFEwEPbfuGIB3IvbHN4fIC8ykYgErUmSpNcVvaTI2LmLmnd67bLWzR27sHGBz6Br1vgM+wKfF6v5ZpMng8FgMBgMBoPBYDAYDAaDwWAwGAwGg8Fg8Kvhc24dFW4kJ9d/O7iOSvg6yl7n9mQxRsm9iDmiSZJ+UE+uma1eBKfbxyyCnwx+iuBIflBsfZIk6bs++Tcjn3XmlBsAAAAASUVORK5CYII=",
  preserveAspectRatio: "none"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--theme-primary, #810ea9)",
  mask: "url(#logo_6d6e9a70a3bc6947__a)",
  shapeRendering: "crispEdges",
  d: "M0 0h120v120H0z"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"120\" height=\"120\" text-rendering=\"geometricPrecision\" viewBox=\"0 0 120 120\"><defs><mask id=\"layer-0\" width=\"120\" height=\"120\" x=\"0\" y=\"0\" mask-type=\"alpha\" maskUnits=\"userSpaceOnUse\"><image xlink:href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAB4CAMAAAAOusbgAAAAIVBMVEVMaXH///////////////////////////////////////8c1D1MAAAACnRSTlMAShEovPB5leDQZCHg2QAAAAlwSFlzAAAD6AAAA+gBtXtSawAAAOtJREFUeNrt1OuOgyAQQGEYHMB5/wde6oq7kIY2YhObnO+POTFBuahzAADgbuTrBr7xawnnCQAAAAA+Isi4vYzyvGjWDJVM3aCT5Utm69xi5h/Xd7pc1Mwdt0/zpr4MHBdLTa9H5/8dS1p5j2xxfpmrrZcjtevlSc6sdK4j+bZ1b226yym/k9C6abI+b2kyTx9sqYuXwzsd1vb2eanb07/O3R6v1+5xOaOpzCLlfaS4nWBLerTunWqWp8Y9p54ctu9U6u/oRZfL4wMQf8U/pCxv6Fra46eDnDlgPow7hkECAAAAAAAAAAAAwHk/auULd1tG0d4AAAAASUVORK5CYII=\" width=\"120\" height=\"120\" href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAB4CAMAAAAOusbgAAAAIVBMVEVMaXH///////////////////////////////////////8c1D1MAAAACnRSTlMAShEovPB5leDQZCHg2QAAAAlwSFlzAAAD6AAAA+gBtXtSawAAAOtJREFUeNrt1OuOgyAQQGEYHMB5/wde6oq7kIY2YhObnO+POTFBuahzAADgbuTrBr7xawnnCQAAAAA+Isi4vYzyvGjWDJVM3aCT5Utm69xi5h/Xd7pc1Mwdt0/zpr4MHBdLTa9H5/8dS1p5j2xxfpmrrZcjtevlSc6sdK4j+bZ1b226yym/k9C6abI+b2kyTx9sqYuXwzsd1vb2eanb07/O3R6v1+5xOaOpzCLlfaS4nWBLerTunWqWp8Y9p54ctu9U6u/oRZfL4wMQf8U/pCxv6Fra46eDnDlgPow7hkECAAAAAAAAAAAAwHk/auULd1tG0d4AAAAASUVORK5CYII=\" preserveAspectRatio=\"none\" style=\"image-rendering:crisp-edges\"/></mask></defs><image xlink:href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAB4CAMAAAAOusbgAAAAGFBMVEVMaXEAAAAAAAAAAAAAAAAAAAAAAAAAAACrC2ehAAAAB3RSTlMAgEa04PDQNfppbQAAAAlwSFlzAAAD6AAAA+gBtXtSawAAAJ1JREFUeNrt2sENwyAMQFEwEPbfuGIB3IvbHN4fIC8ykYgErUmSpNcVvaTI2LmLmnd67bLWzR27sHGBz6Br1vgM+wKfF6v5ZpMng8FgMBgMBoPBYDAYDAaDwWAwGAwGg8Fg8Kvhc24dFW4kJ9d/O7iOSvg6yl7n9mQxRsm9iDmiSZJ+UE+uma1eBKfbxyyCnwx+iuBIflBsfZIk6bs++Tcjn3XmlBsAAAAASUVORK5CYII=\" id=\"convert2-underlay\" width=\"120\" height=\"120\" href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAB4CAMAAAAOusbgAAAAGFBMVEVMaXEAAAAAAAAAAAAAAAAAAAAAAAAAAACrC2ehAAAAB3RSTlMAgEa04PDQNfppbQAAAAlwSFlzAAAD6AAAA+gBtXtSawAAAJ1JREFUeNrt2sENwyAMQFEwEPbfuGIB3IvbHN4fIC8ykYgErUmSpNcVvaTI2LmLmnd67bLWzR27sHGBz6Br1vgM+wKfF6v5ZpMng8FgMBgMBoPBYDAYDAaDwWAwGAwGg8Fg8Kvhc24dFW4kJ9d/O7iOSvg6yl7n9mQxRsm9iDmiSZJ+UE+uma1eBKfbxyyCnwx+iuBIflBsfZIk6bs++Tcjn3XmlBsAAAAASUVORK5CYII=\" preserveAspectRatio=\"none\"/><rect width=\"120\" height=\"120\" fill=\"var(--theme-primary, #810ea9)\" mask=\"url(#layer-0)\" shape-rendering=\"crispEdges\"/></svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/logo.6d6e9a70a3bc69471e3f1fe0b658b971.svg"),
        {
          React: SvgLogo,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      